<nav class="sidebar">
  <div class="sidebar-sticky">
    <ul class="nav flex-column menu">
      <li class="nav-item" routerLinkActive="active">
        <a class="nav-link" [routerLink]="'./books'">
          <i class="fas fa-book"></i>
          <span> {{ "books" | translate }} </span>
        </a>
      </li>
      <li class="nav-item" routerLinkActive="active">
        <a class="nav-link" [routerLink]="'./authors'">
          <i class="fas fa-pen"></i>
          <span>{{ "authors" | translate }}</span>
        </a>
      </li>
      <li class="nav-item" routerLinkActive="active">
        <a class="nav-link" [routerLink]="'./genres'">
          <i class="fas fa-puzzle-piece"></i>
          <span> {{ "genres" | translate }} </span>
        </a>
      </li>
      <li
        class="nav-item"
        routerLinkActive="active"
        *ngIf="userRole === 'admin'"
      >
        <a class="nav-link" [routerLink]="'./users'"
          ><i class="fas fa-users"></i>
          <span> {{ "users" | translate }} </span>
        </a>
      </li>
    </ul>
    <div *ngIf="userRole === 'admin'">
      <h6
        class="
          sidebar-heading
          d-flex
          justify-content-between
          align-items-center
          px-3
          mt-4
          mb-1
          text-muted
        "
      >
        <span class="sectionName">{{ "edit" | translate }}</span>
        <a class="d-flex align-items-center text-muted" href="#"> </a>
      </h6>
      <ul class="nav flex-column menu">
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" routerLink="/addBook">
            <i class="fas fa-book-medical"></i>
            <span>{{ "add" | translate }} {{ "book" | translate }} </span>
          </a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" routerLink="/addAuthor">
            <i class="fas fa-user-plus"></i>
            <span>{{ "add" | translate }} {{ "author" | translate }} </span>
          </a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" routerLink="/pendingBooks">
            <i class="fas fa-user-plus"></i>
            <span>{{ "pendingBooks" | translate }} </span>
          </a>
        </li>
        <!-- <li class="nav-item" [class]="activePage === 'addGenre' ? 'active' : ''">
        <a class="nav-link" href="#" (click)="changePage('addGenre')">
          <i class="fas fa-plus-circle"></i>
          <span>{{ "add" | translate }} {{ "genre" | translate }} </span>
        </a>
      </li> -->
      </ul>
    </div>
  </div>
</nav>
